// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"678":"ef7a1a71","1273":"7180805a","2401":"f1588a71","7786":"d4cc085e","9263":"5542d9aa"}[chunkId] + ".chunk.css";
};